import React from "react";

import { Grid, Typography } from "@material-ui/core";

import { InputSelector, InputText } from "../../../../components";
import InputLookupMembers from "../../../basics/lookup/members";

export default function ArquivosExtratoAplicacao({ attr, setAttr }) {
    return (
        <>
            <Grid container spacing={1}>
                <Grid item xs={6}>
                    <InputLookupMembers
                        roleMember="branch"
                        label="Estabelecimento"
                        value={attr.branch}
                        onChangeValue={(data) => {
                            if (!data) {
                                setAttr({
                                    ...attr,
                                    branch: {},
                                });
                            } else {
                                setAttr({
                                    ...attr,
                                    branch: {
                                        id: data.id,
                                        document: data.document,
                                        name: data.name,
                                        type_member: data.type_member,
                                        state_id: data.state_id,
                                        city_name: data.city_name,
                                        city_id: data.city_id,
                                    },
                                });
                            }
                        }}
                        required={true}
                    />
                </Grid>
                <Grid item xs={6}>
                    <InputSelector
                        label="Replicar para Matriz"
                        value={attr?.replicate_headquarts || false}
                        onChangeValue={(e) => setAttr({ ...attr, replicate_headquarts: e.target.checked })}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={1} style={{ paddingTop: "8px" }}>
                <Grid item xs={12}>
                    <Typography variant="subtitle1">Aplicações (Coluna D)</Typography>
                </Grid>
                <Grid item xs={2}>
                    <InputText
                        label="Conta Débito"
                        value={attr?.cold_debit_account || ""}
                        onChangeValue={(e) => setAttr({ ...attr, cold_debit_account: e.target.value })}
                    />
                </Grid>
                <Grid item xs={2}>
                    <InputText
                        label="Conta Crédito"
                        value={attr?.cold_credit_account || ""}
                        onChangeValue={(e) => setAttr({ ...attr, cold_credit_account: e.target.value })}
                    />
                </Grid>
                <Grid item xs={2}>
                    <InputText label="Histórico" value={attr?.cold_history || ""} onChangeValue={(e) => setAttr({ ...attr, cold_history: e.target.value })} />
                </Grid>
            </Grid>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Typography variant="subtitle1">IOF Retido (Coluna H)</Typography>
                </Grid>
                <Grid item xs={2}>
                    <InputText
                        label="Conta Débito"
                        value={attr?.colh_debit_account || ""}
                        onChangeValue={(e) => setAttr({ ...attr, colh_debit_account: e.target.value })}
                    />
                </Grid>
                <Grid item xs={2}>
                    <InputText
                        label="Conta Crédito"
                        value={attr?.colh_credit_account || ""}
                        onChangeValue={(e) => setAttr({ ...attr, colh_credit_account: e.target.value })}
                    />
                </Grid>
                <Grid item xs={2}>
                    <InputText label="Histórico" value={attr?.colh_history || ""} onChangeValue={(e) => setAttr({ ...attr, colh_history: e.target.value })} />
                </Grid>
            </Grid>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Typography variant="subtitle1">IRRF Retido (Coluna I)</Typography>
                </Grid>
                <Grid item xs={2}>
                    <InputText
                        label="Conta Débito"
                        value={attr?.coli_debit_account || ""}
                        onChangeValue={(e) => setAttr({ ...attr, coli_debit_account: e.target.value })}
                    />
                </Grid>
                <Grid item xs={2}>
                    <InputText
                        label="Conta Crédito"
                        value={attr?.coli_credit_account || ""}
                        onChangeValue={(e) => setAttr({ ...attr, coli_credit_account: e.target.value })}
                    />
                </Grid>
                <Grid item xs={2}>
                    <InputText label="Histórico" value={attr?.coli_history || ""} onChangeValue={(e) => setAttr({ ...attr, coli_history: e.target.value })} />
                </Grid>
            </Grid>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Typography variant="subtitle1">Liquido Resgatado (Coluna J)</Typography>
                </Grid>
                <Grid item xs={2}>
                    <InputText
                        label="Conta Débito"
                        value={attr?.colj_debit_account || ""}
                        onChangeValue={(e) => setAttr({ ...attr, colj_debit_account: e.target.value })}
                    />
                </Grid>
                <Grid item xs={2}>
                    <InputText
                        label="Conta Crédito"
                        value={attr?.colj_credit_account || ""}
                        onChangeValue={(e) => setAttr({ ...attr, colj_credit_account: e.target.value })}
                    />
                </Grid>
                <Grid item xs={2}>
                    <InputText label="Histórico" value={attr?.colj_history || ""} onChangeValue={(e) => setAttr({ ...attr, colj_history: e.target.value })} />
                </Grid>
            </Grid>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Typography variant="subtitle1">Rendimento Bruto (Coluna K)</Typography>
                </Grid>
                <Grid item xs={2}>
                    <InputText
                        label="Conta Débito"
                        value={attr?.colk_debit_account || ""}
                        onChangeValue={(e) => setAttr({ ...attr, colk_debit_account: e.target.value })}
                    />
                </Grid>
                <Grid item xs={2}>
                    <InputText
                        label="Conta Crédito"
                        value={attr?.colk_credit_account || ""}
                        onChangeValue={(e) => setAttr({ ...attr, colk_credit_account: e.target.value })}
                    />
                </Grid>
                <Grid item xs={2}>
                    <InputText label="Histórico" value={attr?.colk_history || ""} onChangeValue={(e) => setAttr({ ...attr, colk_history: e.target.value })} />
                </Grid>
            </Grid>
        </>
    );
}

export function ValidadeArquivosExtratoAplicacao(data) {
    const message = [];

    if (!data?.branch?.id) {
        message.push("Informe o estabelecimento para geração.");
    }

    /*if (!data?.conta_debito) {
        message.push("Informe a conta débito.");
    }

    if (!data?.conta_credito) {
        message.push("Informe a conta crédito.");
    }

    if (!data?.historico) {
        message.push("Informe o histórico.");
    }*/

    return {
        status: message.length === 0,
        data: {
            branch_document: data?.branch.document,
            branch_id: data?.branch.id,

            cold_debit_account: data.cold_debit_account,
            cold_credit_account: data.cold_credit_account,
            cold_history: data.cold_history,

            colh_debit_account: data.colh_debit_account,
            colh_credit_account: data.colh_credit_account,
            colh_history: data.colh_history,

            coli_debit_account: data.coli_debit_account,
            coli_credit_account: data.coli_credit_account,
            coli_history: data.coli_history,

            colj_debit_account: data.colj_debit_account,
            colj_credit_account: data.colj_credit_account,
            colj_history: data.colj_history,

            colk_debit_account: data.colk_debit_account,
            colk_credit_account: data.colk_credit_account,
            colk_history: data.colk_history,

            replicate_headquarts: data.replicate_headquarts ? "Y" : "N",
        },
        message,
    };
}
